// extracted by mini-css-extract-plugin
export default {"backdrop":"styles-module__backdrop--PZCHe","backdropCloseButton":"styles-module__backdropCloseButton--Bv3HB","backdropContent":"styles-module__backdropContent--CUxQi"};